import { useState, useCallback } from 'react';
import useRangePlanningItemsApi from './useRangePlanningItemsApi';
import { RangePlanningItem } from '../types';

const useRangePlanningItemDetail = () => {
  const { getItemDetail } = useRangePlanningItemsApi();
  const [item, setItem] = useState<RangePlanningItem | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadItem = useCallback(async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const detail = await getItemDetail(id);
      setItem(detail);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load item');
      setItem(null);
    } finally {
      setIsLoading(false);
    }
  }, [getItemDetail]);

  return { item, isLoading, error, loadItem, setItem };
};

export default useRangePlanningItemDetail;
